(($) => {

  Formstone.Ready(function() {
    let $deck = $('.block_deck');

    $deck.each(function(index, el) {
      let $slideshow = $(el);

      let $labels = $slideshow.find('.deck_menu_item');
      let Swiper = $slideshow.find('.js-swiper').data('swiper-data').Swiper;

      Swiper.on('slideChange', function(e) {
        $labels.removeClass('active');
        $labels.eq(Swiper.realIndex).addClass('active');
      });

      $labels.on('click', function(e) {
        var index = $labels.index($(e.currentTarget));
        Swiper.slideTo(index + 1);
      });

    });
  });

})(jQuery);
